export enum UserProfileResult {
    SHOW_MY_WALLET,
    NONE
}